import { render } from "./PropertieView.vue?vue&type=template&id=3b2002a0&scoped=true"
import script from "./PropertieView.vue?vue&type=script&lang=js"
export * from "./PropertieView.vue?vue&type=script&lang=js"

import "./PropertieView.vue?vue&type=style&index=0&id=3b2002a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2002a0"]])

export default __exports__